const CreditsIconSVG = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
        <path
            fill="#F8FAFC"
            d="M22 21a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 19 18q0-1.25.875-2.125A2.9 2.9 0 0 1 22 15q1.25 0 2.125.875T25 18t-.875 2.125A2.9 2.9 0 0 1 22 21m-7 3q-.825 0-1.412-.587A1.93 1.93 0 0 1 13 22v-8q0-.824.588-1.413A1.93 1.93 0 0 1 15 12h14q.824 0 1.413.587Q31 13.175 31 14v8q0 .824-.587 1.413A1.93 1.93 0 0 1 29 24zm2-2h10q0-.824.587-1.413A1.93 1.93 0 0 1 29 20v-4q-.824 0-1.413-.588A1.93 1.93 0 0 1 27 14H17q0 .825-.588 1.412A1.93 1.93 0 0 1 15 16v4q.825 0 1.412.587Q17 21.175 17 22m11 6H11q-.824 0-1.413-.587A1.93 1.93 0 0 1 9 26V15h2v11h17zm-12.963-6v-8z"
        ></path>
    </svg>
);

export default CreditsIconSVG;
